import { useStore } from 'zustand'

import {
  useBuyersCardStore,
  useBuyerStore,
  useCardRowsStore,
  usePurchaserLimitsStore,
  usePurchasersFilterStore,
  usePurchaserStore,
} from 'src/features'

export default function useResetStoreStates(): () => void {
  const resetPurchaserState = useStore(
    usePurchaserStore,
    state => state.resetPurchaserState
  )
  const resetPurchasersFilterState = useStore(
    usePurchasersFilterStore,
    state => state.resetPurchasersFilterStoreState
  )
  const resetCardRowsState = useStore(
    useCardRowsStore,
    state => state.resetCardRowsState
  )
  const resetBuyerState = useStore(
    useBuyerStore,
    state => state.resetBuyerState
  )
  const resetBuyersCardState = useStore(
    useBuyersCardStore,
    state => state.resetBuyersCardState
  )
  const resetLimitsFilterState = useStore(
    usePurchaserLimitsStore,
    state => state.resetPurchaserLimitsState
  )

  function resetAllStoreStates() {
    resetPurchaserState()
    resetPurchasersFilterState()
    resetCardRowsState()
    resetBuyerState()
    resetBuyersCardState()
    resetLimitsFilterState()
  }

  return resetAllStoreStates
}
